export const ARTICLE_TABS = [
  { id: 1, name: "料亭和露擠壓瓶" },
  { id: 2, name: "鮮美露" },
  { id: 3, name: "源釀醬油" },
  { id: 4, name: "丸大豆本釀醬油" },
];

export const FALLBACK_ARTICLES_BY_TAG = {
  "料亭和露擠壓瓶": [
    {
      title:
        "【日式風味醬油推薦分享】龜甲萬~料亭和露擠壓瓶（鰹魚/昆布香菇）零失敗料理の快速簡易食譜-玉蜀黍香菇炊飯+養生菇菇彩椒+毛豆菇菇炒蛋+香煎豬排",
      link: "https://vigemini.pixnet.net/blog/posts/7121474910",
      image: "",
      tagName: "料亭和露擠壓瓶",
    },
    {
      title:
        "料理 || 日式風味醬油推薦~龜甲萬料亭和露﹝鰹魚/昆布香菇﹞，好拿擠壓瓶，手殘也能做的零失敗料理--【皮蛋豆腐、昆布蒸蛋】，懶人料理簡易食譜分享",
      link: "https://myotherworld.pixnet.net/blog/posts/2036211897",
      image: "https://pimg.1px.tw/myotherworld/1657627081-3712121524-g.jpg",
      tagName: "料亭和露擠壓瓶",
    },
  ],
  "鮮美露": [
    {
      title:
        "龜甲萬鮮美露。水餃沾醬。醬油推薦。零失敗料理。居家必備醬料。簡單一瓶變化出一周五餐家常料理",
      link: "https://achrry8292.pixnet.net/blog/posts/11406055143",
      image: "https://pimg.1px.tw/achrry8292/1657645817-1918958826-g.jpg",
      tagName: "鮮美露",
    },
    {
      title: "【體驗】醬油推薦~●龜甲萬鮮美露●水餃沾醬、零失敗料理/懶人料理/三步驟",
      link: "https://christinachiou.pixnet.net/blog/posts/1033651979",
      image: "https://pimg.1px.tw/christinachiou/1657893600-3493760197-g.jpg",
      tagName: "鮮美露",
    },
    {
      title:
        "水餃醬油推薦：龜甲萬鮮美露，美味水餃沾醬做法大公開！快來領取零失敗料理食譜！",
      link: "https://rabbit30895.pixnet.net/blog/posts/8232278964",
      image: "https://pimg.1px.tw/rabbit30895/1662218748-1380996461-g.jpg",
      tagName: "鮮美露",
    },
  ],
  "源釀醬油": [
    {
      title: "【居家推薦】馬鈴薯燉肉、涼拌茄子，好吃醬油成就零失敗料理！",
      link: "https://abcjcba.pixnet.net/blog/posts/5070138644",
      image: "https://pimg.1px.tw/abcjcba/1658805417-3856621482-g.jpg",
      tagName: "源釀醬油",
    },
    {
      title:
        "【食譜】零失敗料理分享-馬鈴薯燉肉&醬燒杏鮑菇｜醬油推薦使用龜甲萬-丸大豆本釀醬油｜日本釀造｜無糖無化學合成｜簡單一匙增添料理風味",
      link: "https://eggface0507.pixnet.net/blog/posts/9565209558",
      image: "https://pimg.1px.tw/eggface0507/1658236862-3734469775-g.jpg",
      tagName: "源釀醬油",
    },
  ],
  "丸大豆本釀醬油": [
    {
      title:
        "【食譜】零失敗料理分享-馬鈴薯燉肉&醬燒杏鮑菇｜醬油推薦使用龜甲萬-丸大豆本釀醬油｜日本釀造｜無糖無化學合成｜簡單一匙增添料理風味",
      link: "https://eggface0507.pixnet.net/blog/posts/9565209558",
      image: "https://pimg.1px.tw/eggface0507/1658236862-3734469775-g.jpg",
      tagName: "丸大豆本釀醬油",
    },
    {
      title:
        "【醬油推薦】美味料理的靈魂是醬油|家常料理的好夥伴|龜甲萬丸大豆本釀醬油|泰式豬肉蛋炒飯、醬醃小黃瓜、馬鈴薯燉肉",
      link: "https://hsiuying.pixnet.net/blog/posts/5070124166",
      image: "https://pimg.1px.tw/hsiuying/1657686218-788030707-g.png",
      tagName: "丸大豆本釀醬油",
    },
  ],
};
